// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3B3Gi","row":"Node_row__23V4J","label":"Node_label__fGCP-","footer":"Node_footer__i9Gca"};